import { render, staticRenderFns } from "./CtaNew.vue?vue&type=template&id=3d32866c&lang=pug"
import script from "./CtaNew.vue?vue&type=script&lang=js"
export * from "./CtaNew.vue?vue&type=script&lang=js"
import style0 from "./CtaNew.vue?vue&type=style&index=0&id=3d32866c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports